import { ViewModel,View } from "binder"
import { getAsNumber } from "src/uicomponents/components/utilities";
import { IDefaultValueManipulator } from "../defaultValueManipulator";
import  { FloatView } from "./float-view"

export class FloatViewModel extends ViewModel implements IDefaultValueManipulator{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new FloatView();
    }
    public getTypeId(): string {
        return "VM-DF5FC3D5-4782-4E68-B746-CB2CC7FFE5AA"
    }

    public set value(v: number) { this._value = getAsNumber(v,true); } public get value(): number { return this._value;} private _value: number;
    
    
    setDefaultValue(defaultValue: any): void {
        this.value = defaultValue;
    }
    getDefaultValue():any {
        return this.value;
    }
}
